/**
 * Mock Data for Checkout Wizard Mockup
 * This file contains realistic dummy data for stakeholder presentation
 * No actual API calls are made - all data is static
 */

// Store Information
export const mockStoreDetails = {
  ClientStoreId: "1",
  ClientStoreName: "Downtown Market",
  company_name: "Fresh Foods Inc.",
  delivery_method_lable: "Delivery",
  third_party_delivery_option: "door_dash",
  third_party_delivery_option_lable: "DoorDash",
  allow_pickup: "1",
  allow_delivery: "1",
  allow_tip_amount: "1",
  is_curbside_pickup: "1",
  allow_curbside_pickup_required_or_optional: "0", // optional
  allow_default_curbside_pickup: "0",
  curbside_instruction_notes: "Please provide your vehicle details for curbside pickup",
  pickup_cc: "1",
  pickup_cod: "1",
  delivery_cc: "1",
  delivery_cod: "1",
  pickup_cod_lable: "Pay at Store",
  delivery_cod_lable: "Pay on Delivery",
  allow_pickup_ebt: "1",
  allow_delivery_ebt: "1",
  allow_ecom_pickup_house_charge: "1",
  allow_ecom_delivery_house_charge: "1",
  is_approved_tax_exempt: "1",
  TaxExemptAcceptanceNoticeMessage: "I confirm that this order qualifies for tax exemption under applicable state law.",
  include_printed_receipt_with_order: "1",
  IncludePrintedReceiptWithOrderMessage: "Include printed receipt with my order",
  payment_gateway: "stripe",
  store_address: "456 Market Street",
  store_city: "Springfield",
  store_state: "IL",
  store_zip: "62701",
  store_phone: "(555) 987-6543",
};

// Customer Addresses
export const mockAddresses = {
  shipping: [
    {
      id: "addr_001",
      first_name: "John",
      last_name: "Smith",
      address_1: "1234 Oak Street",
      address_2: "Apt 4B",
      city: "Springfield",
      state: "IL",
      zip_code: "62701",
      contact: "5551234567",
      is_primary: "1",
      status: "shipping",
    },
    {
      id: "addr_002",
      first_name: "John",
      last_name: "Smith",
      address_1: "567 Maple Avenue",
      address_2: "",
      city: "Springfield",
      state: "IL",
      zip_code: "62702",
      contact: "5559876543",
      is_primary: "0",
      status: "shipping",
    },
    {
      id: "addr_003",
      first_name: "John",
      last_name: "Smith",
      address_1: "789 Pine Road",
      address_2: "Suite 100",
      city: "Springfield",
      state: "IL",
      zip_code: "62703",
      contact: "5554567890",
      is_primary: "0",
      status: "shipping",
    }
  ],
  billing: [
    {
      id: "bill_001",
      first_name: "John",
      last_name: "Smith",
      address_1: "1234 Oak Street",
      address_2: "Apt 4B",
      city: "Springfield",
      state: "IL",
      zip_code: "62701",
      contact: "5551234567",
      is_primary: "1",
      status: "billing",
    },
    {
      id: "bill_002",
      first_name: "John",
      last_name: "Smith",
      address_1: "567 Maple Avenue",
      address_2: "",
      city: "Springfield",
      state: "IL",
      zip_code: "62702",
      contact: "5559876543",
      is_primary: "0",
      status: "billing",
    }
  ]
};

// Time Slots
export const mockTimeSlots = [
  { 
    title: "Today, Jan 29 • 2:00 PM - 3:00 PM", 
    value: { shipping_date: "2026-01-29", shipping_time: "14:00-15:00" },
    label: "Today, Jan 29",
    time: "2:00 PM - 3:00 PM"
  },
  { 
    title: "Today, Jan 29 • 3:00 PM - 4:00 PM", 
    value: { shipping_date: "2026-01-29", shipping_time: "15:00-16:00" },
    label: "Today, Jan 29",
    time: "3:00 PM - 4:00 PM"
  },
  { 
    title: "Today, Jan 29 • 4:00 PM - 5:00 PM", 
    value: { shipping_date: "2026-01-29", shipping_time: "16:00-17:00" },
    label: "Today, Jan 29",
    time: "4:00 PM - 5:00 PM"
  },
  { 
    title: "Today, Jan 29 • 5:00 PM - 6:00 PM", 
    value: { shipping_date: "2026-01-29", shipping_time: "17:00-18:00" },
    label: "Today, Jan 29",
    time: "5:00 PM - 6:00 PM"
  },
  { 
    title: "Tomorrow, Jan 30 • 10:00 AM - 11:00 AM", 
    value: { shipping_date: "2026-01-30", shipping_time: "10:00-11:00" },
    label: "Tomorrow, Jan 30",
    time: "10:00 AM - 11:00 AM"
  },
  { 
    title: "Tomorrow, Jan 30 • 11:00 AM - 12:00 PM", 
    value: { shipping_date: "2026-01-30", shipping_time: "11:00-12:00" },
    label: "Tomorrow, Jan 30",
    time: "11:00 AM - 12:00 PM"
  },
  { 
    title: "Tomorrow, Jan 30 • 1:00 PM - 2:00 PM", 
    value: { shipping_date: "2026-01-30", shipping_time: "13:00-14:00" },
    label: "Tomorrow, Jan 30",
    time: "1:00 PM - 2:00 PM"
  },
];

// Price List / Order Summary
export const mockPriceList = [
  { key_name: "item_total", title: "Item Total (8 items)", amount: "89.97", is_visible: 1, sort_order: 1 },
  { key_name: "discount", title: "Store Discount", amount: "-10.00", is_visible: 1, sort_order: 2, style: { color: "#16a34a" } },
  { key_name: "coupon_discount", title: "Coupon (SAVE10)", amount: "-5.00", is_visible: 1, sort_order: 3, style: { color: "#16a34a" } },
  { key_name: "tax", title: "Tax", amount: "4.50", is_visible: 1, sort_order: 4 },
  { key_name: "delivery_fee", title: "Delivery Fee", amount: "5.99", is_visible: 1, sort_order: 5 },
  { key_name: "tip", title: "Driver Tip", amount: "5.00", is_visible: 1, sort_order: 6 },
  { key_name: "grand_total", title: "Grand Total", amount: "90.46", is_visible: 1, sort_order: 7, style: { fontWeight: "bold", fontSize: "1.1rem" } },
  { key_name: "authorized_amount", title: "Authorized Amount", amount: "99.51", is_visible: 1, sort_order: 8, style: { fontWeight: "bold", color: "#2563eb" } },
];

// Pickup Price List (no delivery fee or tip)
export const mockPickupPriceList = [
  { key_name: "item_total", title: "Item Total (8 items)", amount: "89.97", is_visible: 1, sort_order: 1 },
  { key_name: "discount", title: "Store Discount", amount: "-10.00", is_visible: 1, sort_order: 2, style: { color: "#16a34a" } },
  { key_name: "coupon_discount", title: "Coupon (SAVE10)", amount: "-5.00", is_visible: 1, sort_order: 3, style: { color: "#16a34a" } },
  { key_name: "tax", title: "Tax", amount: "4.50", is_visible: 1, sort_order: 4 },
  { key_name: "grand_total", title: "Grand Total", amount: "79.47", is_visible: 1, sort_order: 5, style: { fontWeight: "bold", fontSize: "1.1rem" } },
  { key_name: "authorized_amount", title: "Authorized Amount", amount: "87.42", is_visible: 1, sort_order: 6, style: { fontWeight: "bold", color: "#2563eb" } },
];

// Cart Info
export const mockCartInfo = {
  minimum_order_amount_message: "",
  remaining_amount: "0",
  authorized_notes: "Your card will be authorized for $99.51 (includes 10% buffer for weight adjustments). Final charge will reflect actual order total.",
  ebt_notes: "EBT SNAP can only be used for eligible food items. Non-food items will be charged separately.",
  checkout_pricing_notes: "Prices may vary due to weight adjustments on weighted items.",
  age_restricted_notes: "This order contains age-restricted items. You must be 21+ to purchase.",
  curbside_instruction_notes: "Please provide vehicle details for curbside pickup",
  house_charge_amount: "250.00",
  is_curbside_pickup: "1",
  external_delivery_id: "", // Will be set when DoorDash confirms
};

// Cart Info with Minimum Order Not Met
export const mockCartInfoMinimumNotMet = {
  ...mockCartInfo,
  minimum_order_amount_message: "<strong>Minimum order amount not met!</strong> Please add <strong>$15.00</strong> more to your cart to proceed with checkout.",
  remaining_amount: "15.00",
};

// Applied Coupons
export const mockCoupons = [
  { coupon_value: "SAVE10", coupon_title: "Save $10 on orders over $50", is_auto_applied: true },
  { coupon_value: "FREESHIP", coupon_title: "Free shipping on first order", is_auto_applied: false },
  { coupon_value: "WELCOME20", coupon_title: "20% off for new customers", is_auto_applied: false },
];

// EBT Paid List (for split payment demo)
export const mockEbtPaidList = [
  { 
    card_number: "****1234", 
    amount: "25.00", 
    balance: "175.00", 
    transaction_id: "EBT123456",
    payment_date: "2026-01-29 14:30:00"
  },
];

// Empty EBT paid list (default state)
export const mockEbtPaidListEmpty = [];

// User Info
export const mockUser = {
  first_name: "John",
  last_name: "Smith",
  email: "john.smith@example.com",
  mobile_number: "5551234567",
  member_number: "MEM001234",
};

// Catering Pickup Persons
export const mockPickupPersons = [
  { id: 1, first_name: "Jane", last_name: "Doe", email: "jane.doe@company.com" },
];

// DoorDash Options
export const mockDoorDashOptions = [
  { value: "Leave at my door", label: "Leave at my door" },
  { value: "Hand it to me", label: "Hand it to me" },
];

// Tip Options
export const mockTipOptions = [
  { value: 0, label: "No Tip", percentage: "0%" },
  { value: 3, label: "$3", percentage: "" },
  { value: 5, label: "$5", percentage: "" },
  { value: 7, label: "$7", percentage: "" },
  { value: "custom", label: "Custom", percentage: "" },
];

// Contact Type Options
export const mockContactTypes = [
  { value: "call_me", label: "Call me" },
  { value: "text_me", label: "Text me" },
];

// Payment Methods
export const mockPaymentMethods = {
  grocery: {
    pickup: [
      { value: "cc", label: "Credit/Debit Card", icon: "fa-credit-card" },
      { value: "cod", label: "Pay at Store", icon: "fa-money-bill" },
      { value: "ebt", label: "EBT SNAP", icon: "fa-id-card" },
      { value: "house_charge", label: "House Charge", icon: "fa-building", balance: "250.00" },
    ],
    delivery: [
      { value: "cc", label: "Credit/Debit Card", icon: "fa-credit-card" },
      { value: "cod", label: "Pay on Delivery", icon: "fa-money-bill" },
      { value: "ebt", label: "EBT SNAP", icon: "fa-id-card" },
      { value: "house_charge", label: "House Charge", icon: "fa-building", balance: "250.00" },
    ],
  },
};

// Cart Items (for Edit Cart preview)
export const mockCartItems = [
  { id: 1, name: "Organic Bananas", quantity: 2, price: "2.99", image: "" },
  { id: 2, name: "Whole Milk 1 Gallon", quantity: 1, price: "4.49", image: "" },
  { id: 3, name: "Fresh Bread Loaf", quantity: 1, price: "3.29", image: "" },
  { id: 4, name: "Chicken Breast 2lb", quantity: 1, price: "12.99", image: "" },
  { id: 5, name: "Mixed Salad Greens", quantity: 1, price: "4.99", image: "" },
  { id: 6, name: "Pasta Sauce", quantity: 2, price: "3.49", image: "" },
  { id: 7, name: "Ground Coffee 12oz", quantity: 1, price: "8.99", image: "" },
  { id: 8, name: "Orange Juice 64oz", quantity: 1, price: "5.99", image: "" },
];

// Wizard Steps Configuration
export const wizardSteps = [
  { 
    id: 1, 
    title: "Delivery & Scheduling",
    shortTitle: "Delivery",
    icon: "fa-truck",
    description: "Choose pickup or delivery and select a time"
  },
  { 
    id: 2, 
    title: "Contact & Address",
    shortTitle: "Address",
    icon: "fa-location-dot",
    description: "Provide contact info and delivery address"
  },
  { 
    id: 3, 
    title: "Review & Payment",
    shortTitle: "Payment",
    icon: "fa-credit-card",
    description: "Review your order and complete payment"
  },
];

// Initial Form State
export const initialFormState = {
  // Step 1
  deliveryMethod: "delivery", // "store_pickup" | "delivery"
  selectedTimeSlot: null,
  doorDashContactless: "Leave at my door",
  dropOffInstructions: "",
  tipAmount: 5,
  doorDashConfirmed: false,
  isCurbsidePickup: false,
  curbsideComment: "",
  
  // Step 2
  contactType: "call_me",
  contactNumber: "5551234567",
  orderNotes: "",
  selectedDeliveryAddress: "addr_001",
  pickupPersons: [],
  
  // Step 3
  isTaxExempt: false,
  ageRestrictionAccepted: false,
  includePrintedReceipt: false,
  selectedPaymentMethod: "cc",
  selectedBillingAddress: "bill_001",
};
